export const orderStatusMode = {
  NEW: 1,
  WAITING: 6,
};

export const orderTypeMode = {
  RESULT_TYPE: 1,
  RECEIVE_TYPE: 2,
};

export const getTimeSlotParams = () => {
  return {
    page: -1,
    sort: "from_time,to_time",
    columnFilter: {},
  };
};

export const canCancelOrder = status => {
  return [1, 6].includes(status);
};
